var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"e-chip-label",style:(_vm.styles)},[(_vm.prependIcon)?_c('e-svg-icon',{attrs:{"name":_vm.prependIcon}}):_vm._e(),_c('span',{staticClass:"text-12px",style:(_vm.textStyles)},[_vm._v(_vm._s(_vm.text))]),(_vm.appendIcon)?_c('e-svg-icon',{attrs:{"name":_vm.appendIcon}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }